import lrEditor from './_src/lrEditor.vue'

lrEditor.install = function(Vue) {
  Vue.component(lrEditor.name, lrEditor)
}

export default lrEditor